import {isFeatureEnabled} from 'feature-flags';

import {ReactNode} from 'react';

import {featureFlags} from '@dms/feature-flags';
import {buildUrl} from '@dms/routes';
import {
  bulkOperationsServices,
  entityResourceResolver,
  useGetUserOptions,
  usePermissions,
} from '@dms/shared';

import {EagGridConfigProvider} from 'features/eag-grid';

import {useDownloadExportedFiles} from './hooks/useDownloadExportedFiles';

type DataGridContainerProps = {
  children: ReactNode;
};

export function DataGridContainer(props: DataGridContainerProps) {
  const {handleExportSuccessfullyStarted} = useDownloadExportedFiles();

  return (
    <EagGridConfigProvider
      value={{
        app: 'dms',
        bulkOperations: isFeatureEnabled(featureFlags.DATA_GRID_BULK_OPERATIONS)
          ? bulkOperationsServices
          : undefined,
        entityResourceResolver,
        buildAbsoluteUrl: buildUrl,
        useGetUserOptions,
        usePermissions,
        handleExportSuccessfullyStarted,
      }}
    >
      {props.children}
    </EagGridConfigProvider>
  );
}
